import { useContext } from 'react'
import { AiJobContext } from './aiJobContextCore'

export const useAiJob = () => {
  const context = useContext(AiJobContext)
  if (!context) throw new Error('useAiJob must be used within AiJobProvider')
  return context
}
